module.exports = __webpack_public_path__ + "img/convert-currency.d7a99b05.png";